<template>
  <div
    id="apexcharts3fj8rzvf"
    class="apexcharts-canvas apexcharts3fj8rzvf apexcharts-theme-light"
    style="width: 766px; height: 302.7px;"
  >
    <svg
      id="SvgjsSvg1116"
      width="766"
      height="302.7"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns:svgjs="http://svgjs.com/svgjs"
      class="apexcharts-svg"
      xmlns:data="ApexChartsNS"
      transform="translate(0, 0)"
      style="background: transparent;"
    >
        <defs>
            <linearGradient id="loader-gradient" x1="0" y1="0" x2="100%" y2="0" >
                <stop offset="0" stop-color="dddddd">
                    <animate attributeName="stop-color" values="eeeeee;dddddd;eeeeee" dur="2s" repeatCount="indefinite"  /> 
                </stop>
            </linearGradient>
        </defs>

      <foreignObject x="0" y="0" width="766" height="302.7">
        <div
          class="apexcharts-legend apexcharts-align-center position-right"
          xmlns="http://www.w3.org/1999/xhtml"
          style="position: absolute; left: auto; top: 20px; right: 5px; min-width: 250px;"
        >
          <div class="apexcharts-legend-series" style="margin: 0px 5px;">
            <span class="apexcharts-legend-loader"></span>
          </div>
          <div class="apexcharts-legend-series" style="margin: 0px 5px;">
            <span class="apexcharts-legend-loader"></span>
          </div>
          <div class="apexcharts-legend-series" style="margin: 0px 5px;">
            <span class="apexcharts-legend-loader"></span>
          </div>
          <div class="apexcharts-legend-series" style="margin: 0px 5px;">
            <span class="apexcharts-legend-loader"></span>
          </div>
        </div>
      </foreignObject>
      <g
        id="SvgjsG1118"
        class="apexcharts-inner apexcharts-graphical"
        transform="translate(22, 0)"
      >
        <g id="SvgjsG1123" class="apexcharts-pie">
          <g id="SvgjsG1124" transform="translate(46.39999999999998, 30) scale(0.8)">
            <circle
              id="SvgjsCircle1125"
              r="91.22195121951219"
              cx="232"
              cy="150"
              fill="transparent"
            />
            <g id="SvgjsG1126" class="apexcharts-slices">
              <g
                id="SvgjsG1127"
                class="apexcharts-series apexcharts-pie-series"
                rel="1"
                data-:real-index="0"
              >
                <path
                  id="SvgjsPath1128"
                  d="M 232 9.658536585365852 A 140.34146341463415 140.34146341463415 0 0 1 344.15770808868456 234.358608746556 L 304.90251025764496 204.8330956852614 A 91.22195121951219 91.22195121951219 0 0 0 232 58.77804878048781 L 232 9.658536585365852 z"
                  fill="url(#loader-gradient)"
                  class="apexcharts-pie-area apexcharts-donut-slice-0"
                  index="0"
                  j="0"
                  data-:angle="126.9483905772343"
                  data-:start-angle="0"
                  data-:stroke-width="2"
                  data-:value="3922"
                  data-:path-orig="M 232 9.658536585365852 A 140.34146341463415 140.34146341463415 0 0 1 344.15770808868456 234.358608746556 L 304.90251025764496 204.8330956852614 A 91.22195121951219 91.22195121951219 0 0 0 232 58.77804878048781 L 232 9.658536585365852 z"
                  stroke="#ffffff"
                />
              </g>
              <g
                id="SvgjsG1129"
                class="apexcharts-series apexcharts-pie-series"
                rel="2"
                data-:real-index="1"
              >
                <path
                  id="SvgjsPath1130"
                  d="M 344.15770808868456 234.358608746556 A 140.34146341463415 140.34146341463415 0 1 1 231.9755057939878 9.65853872288855 L 231.98407876609207 58.778050169877574 A 91.22195121951219 91.22195121951219 0 1 0 304.90251025764496 204.8330956852614 L 344.15770808868456 234.358608746556 z"
                  fill="url(#loader-gradient)"
                  class="apexcharts-pie-area apexcharts-donut-slice-1"
                  index="0"
                  j="1"
                  data-:angle="233.0516094227657"
                  data-:start-angle="126.9483905772343"
                  data-:stroke-width="2"
                  data-:value="7200"
                  data-:path-orig="M 344.15770808868456 234.358608746556 A 140.34146341463415 140.34146341463415 0 1 1 231.9755057939878 9.65853872288855 L 231.98407876609207 58.778050169877574 A 91.22195121951219 91.22195121951219 0 1 0 304.90251025764496 204.8330956852614 L 344.15770808868456 234.358608746556 z"
                  stroke="#ffffff"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style>
.apexcharts-donut-slice-1 {
    background: #fcfdff;
    background: linear-gradient(to right, #eeeeee 10%, #dddddd 18%, #eeeeee 33%);
    background-size: 20px * 20 100%;
}

.apexcharts-legend {
  display: flex;
  overflow: auto;
  padding: 0 10px;
}
.apexcharts-legend.position-bottom,
.apexcharts-legend.position-top {
  flex-wrap: wrap;
}
.apexcharts-legend.position-right,
.apexcharts-legend.position-left {
  flex-direction: column;
  bottom: 0;
}
.apexcharts-legend.position-bottom.apexcharts-align-left,
.apexcharts-legend.position-top.apexcharts-align-left,
.apexcharts-legend.position-right,
.apexcharts-legend.position-left {
  justify-content: flex-start;
}
.apexcharts-legend.position-bottom.apexcharts-align-center,
.apexcharts-legend.position-top.apexcharts-align-center {
  justify-content: center;
}
.apexcharts-legend.position-bottom.apexcharts-align-right,
.apexcharts-legend.position-top.apexcharts-align-right {
  justify-content: flex-end;
}
.apexcharts-legend-series {
  cursor: pointer;
  line-height: normal;
}
.apexcharts-legend.position-bottom .apexcharts-legend-series,
.apexcharts-legend.position-top .apexcharts-legend-series {
  display: flex;
  align-items: center;
}
.apexcharts-legend-text {
  position: relative;
  font-size: 14px;
}
.apexcharts-legend-text *,
.apexcharts-legend-marker * {
  pointer-events: none;
}
.apexcharts-legend-marker {
  position: relative;
  display: inline-block;
  cursor: pointer;
  margin-right: 3px;
  border-style: solid;
}

.apexcharts-legend.apexcharts-align-right .apexcharts-legend-series,
.apexcharts-legend.apexcharts-align-left .apexcharts-legend-series {
  display: inline-block;
}
.apexcharts-legend-series.apexcharts-no-click {
  cursor: auto;
}
.apexcharts-legend .apexcharts-hidden-zero-series,
.apexcharts-legend .apexcharts-hidden-null-series {
  display: none !important;
}
.apexcharts-inactive-legend {
  opacity: 0.45;
}

@keyframes placeHolderShimmer {
    0% {
        background-position: -468px 0;
    }
    100% {
        background-position: 468px 0;
    }
}

.apexcharts-legend-loader {
    height: 25px;
    width: 100%;
    display: block;
    margin: 5px 0;
    border-radius: 5px;

    animation-duration: 5s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: darkgray;
    background: linear-gradient(to right, #eeeeee 10%, #dddddd 20%, #eeeeee 33%);
    background-size: 250px * 4 100%;
    position: relative;
}
</style>